import React from 'react';
import { UPDATE_USERS_NOTE } from 'graphql/mutation/note/updateAll';
import { UPDATE_NOTE_CLASSE } from 'graphql/mutation/note/updateNoteClasse';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import UpdateButton from 'components/organisms/Contents/MyClassContent/UpdateNote/UpdateButton';
import useStyle from './updateButton.style';

export const UpdateNote = () => {
  const classes = useStyle();
  return (
    <FeatureContainer>
      <p>
        Si vous constatez une différence d'affichage entre votre tableau et les
        commandes réellement passées ou quiz répondus par les élèves, utilisez
        les boutons ci-dessous pour mettre à jour les données.
      </p>
      <div className={classes.root}>
        <UpdateButton
          mutation={UPDATE_USERS_NOTE}
          successMessage="Mise à jour effectuée avec succès"
          errorMessage="Erreur dans la mise à jour des notes élèves, veuillez recharger la page"
          buttonMessage="Mettre à jour les notes élèves"
        />
        <UpdateButton
          mutation={UPDATE_NOTE_CLASSE}
          successMessage="Mise à jour effectuée avec succès"
          errorMessage="Erreur dans la mise à jour de la note classe, veuillez recharger la page"
          buttonMessage="Mettre à jour la note classe"
        />
      </div>
    </FeatureContainer>
  );
};
